import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import Api from '../../../../__helpers/api'
import { useAuthDataContext } from '../../../../__providers/AuthProvider';
import { useHistory } from 'react-router-dom'

//images
import multiTestsImg from '../../../../assets/images/profile/guide/tests/1_1.png'
import testsImg from '../../../../assets/images/profile/guide/tests/1_2.png'
import voiceImg from '../../../../assets/images/profile/guide/tests/1_3.png'
import selectedQuestionsImg from '../../../../assets/images/profile/guide/tests/1_4.png'
import questionsImg from '../../../../assets/images/profile/guide/tests/1_5.png'
import repeatTestImg from '../../../../assets/images/profile/guide/tests/1_6.png'

import rightArrowIcon from '../../../../assets/images/profile/right-arrow.png'
import leftArrowIcon from '../../../../assets/images/profile/left-arrow-blue.png'
import buttonPlay from '../../../../assets/images/profile/button-play.png'
import videoGuide from '../../../../assets/images/profile/video-guide-two.mp4'
import closeIcon from '../../../../assets/images/home/x.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

let interval
let timeout
let partlyWatched

function Major(props, ref) {
    const auth = useAuthDataContext();
    let history = useHistory();
    const dispatch = useDispatch()

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        currentStep: 1,
        href: '',
        button: false,
        loaded: 0
    })

    const handleSlide = () => {
        if (major.currentStep == 6) {
            Api.post('student/hide-test-tutor')
            setTimeout(() => {
                history.push('/test?topic_id=1')
            }, 101);

            handleClose()
            return
        }
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 6 ? 6 : major.currentStep + 1
        }))

        let guideSlides
        if (document.getElementsByClassName('no-arrows')) {
            guideSlides = document.getElementsByClassName('no-arrows')[0].children
        }

        if (major.currentStep < 6) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep + 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    const handleBack = () => {
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 1 ? 1 : major.currentStep - 1
        }))

        let guideSlides = document.getElementsByClassName('no-arrows')[0].children

        if (major.currentStep <= 6) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep - 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        document.querySelector('#video_html5_api') && document.querySelector('#video_html5_api').pause()
        
        setMajor(major => ({
            ...major,
            blur: true,
            href: href
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))

            document.getElementById('videoGuide') && document.getElementById('videoGuide').play()

            timeout = setTimeout(() => {
                setMajor(prev => ({
                    ...prev,
                    button: true
                }))
            }, 35000);

            partlyWatched = setTimeout(() => {
                Api.post('student/hide-test-tutor')
                    .then(() => {
                        dispatch(refreshNotification())
                    })
            }, 25000)

            interval = setInterval(() => {
                setMajor(prev => ({
                    ...prev,
                    loaded: prev.loaded + 1.6
                }))
            }, 500);
        }, 50);
    }

    const handleClose = () => {
        dispatch(handleModal('TESTS_GUIDE', false, {}))

        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            clearInterval(interval)
            clearTimeout(timeout)
            if (document.getElementById('videoGuide')) {
                document.getElementById('videoGuide').pause()
                document.getElementById('videoGuide').currentTime = 0
            }

            setMajor(major => ({
                ...major,
                blur: false,
                currentStep: 1,
                button: false,
                loaded: 0,
            }))
            if (document.getElementsByClassName('no-arrows').length > 0) {
                document.getElementsByClassName('no-arrows')[0].children[0].classList.add('active')
            }
            auth.refresh()

            document.querySelector('#video_html5_api') && document.querySelector('#video_html5_api').play()
        }, 100);
    }

    const handleToVideos = () => {
        Api.post('student/hide-test-tutor')
            .then(() => {
                dispatch(refreshNotification())
            })
        setTimeout(() => {
            history.push(`/test?topic_id=${auth.user.current_topic.current}`)
        }, 101);

        handleClose()
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box guide video-guide test-guide ${major.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                />
                <h2>
                    С Авто Обучение по-лесно научаваш листовките
                </h2>
                <video controls disablePictureInPicture id="videoGuide">
                    <source src={videoGuide} type="video/mp4" />
                </video>

                <div className="buttons">
                    <div className="row play-button-row">
                        <div className="loading-bar">
                            <div className="loading" style={{ width: major.loaded + "%" }}>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <Button onClick={handleToVideos} style={{ width: '280px' }}>
                            Към изпитните въпроси
                            <img src={buttonPlay} />
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(Major);